// Notification API service

async function parseJsonSafely(res) {
  const text = await res.text();
  if (!text) {
    return { success: false, empty: true };
  }

  try {
    return JSON.parse(text);
  } catch (_error) {
    return { success: false, malformed: true };
  }
}

async function requestNotifications(url, token, options = {}) {
  const response = await fetch(url, {
    headers: { Authorization: `Bearer ${token}` },
    ...options,
  });

  const data = await parseJsonSafely(response);
  if (!response.ok) {
    const message = data?.error || data?.message || `Request failed with status ${response.status}`;
    throw new Error(message);
  }

  return data;
}

export async function getNotifications(token, params = {}) {
  const query = new URLSearchParams(params).toString();
  return requestNotifications(`/api/notifications${query ? `?${query}` : ''}`, token);
}

export async function getUnreadCount(token) {
  return requestNotifications('/api/notifications/unread/count', token);
}

// Admin: get unread count across all users
export async function getAllUnreadCount(token) {
  return requestNotifications('/api/notifications/unread/count-all', token);
}

export async function getAllNotifications(token, params = {}) {
  const qs = new URLSearchParams(params).toString();
  return requestNotifications(`/api/notifications/all${qs ? `?${qs}` : ''}`, token);
}

export async function markAsReadAsAdmin(notificationId, token) {
  return requestNotifications(`/api/notifications/${notificationId}/read-as-admin`, token, {
    method: 'PUT',
  });
}

export async function markAsRead(notificationId, token) {
  return requestNotifications(`/api/notifications/${notificationId}/read`, token, {
    method: 'PUT',
  });
}

export async function markAllAsRead(token) {
  return requestNotifications('/api/notifications/read-all', token, {
    method: 'PUT',
  });
}

export async function dismissNotification(notificationId, token) {
  return requestNotifications(`/api/notifications/${notificationId}`, token, {
    method: 'DELETE',
  });
}

export async function getPreferences(token) {
  return requestNotifications('/api/notifications/preferences', token);
}

export async function updatePreferences(body, token) {
  return requestNotifications('/api/notifications/preferences', token, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
    body: JSON.stringify(body),
  });
}
